// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "motionplan/v1/motionplan.proto" (package "motionplan.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Offline RDK forward kinematics and IK inspection for motion-plan JSON.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Transform } from "../../common/v1/common";
/**
 * @generated from protobuf message motionplan.v1.ComputePlanFramesRequest
 */
export interface ComputePlanFramesRequest {
    /**
     * Permission scope.
     *
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: bytes plan_content = 2;
     */
    planContent: Uint8Array;
}
/**
 * @generated from protobuf message motionplan.v1.ComputePlanFramesResponse
 */
export interface ComputePlanFramesResponse {
    /**
     * @generated from protobuf field: repeated motionplan.v1.PlanStep steps = 1;
     */
    steps: PlanStep[];
}
/**
 * One trajectory step. Per-frame uuids stay stable so scrub updates entities in place.
 *
 * @generated from protobuf message motionplan.v1.PlanStep
 */
export interface PlanStep {
    /**
     * @generated from protobuf field: repeated viam.common.v1.Transform transforms = 1;
     */
    transforms: Transform[];
}
/**
 * @generated from protobuf message motionplan.v1.GetIKSolutionsRequest
 */
export interface GetIKSolutionsRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: bytes plan_content = 2;
     */
    planContent: Uint8Array;
    /**
     * Solutions to request per seed; 0 means the server default.
     *
     * @generated from protobuf field: int32 num_solutions = 3;
     */
    numSolutions: number;
}
/**
 * @generated from protobuf message motionplan.v1.GetIKSolutionsResponse
 */
export interface GetIKSolutionsResponse {
    /**
     * @generated from protobuf field: repeated motionplan.v1.IKSeedResult results = 1;
     */
    results: IKSeedResult[];
}
/**
 * @generated from protobuf message motionplan.v1.IKSeedResult
 */
export interface IKSeedResult {
    /**
     * @generated from protobuf field: string seed = 1;
     */
    seed: string;
    /**
     * @generated from protobuf field: repeated motionplan.v1.IKSolution solutions = 2;
     */
    solutions: IKSolution[];
}
/**
 * @generated from protobuf message motionplan.v1.IKSolution
 */
export interface IKSolution {
    /**
     * @generated from protobuf field: double cost = 1;
     */
    cost: number;
    /**
     * @generated from protobuf field: map<string, motionplan.v1.JointPositions> configuration = 2;
     */
    configuration: {
        [key: string]: JointPositions;
    };
    /**
     * @generated from protobuf field: bool configuration_valid = 3;
     */
    configurationValid: boolean;
    /**
     * @generated from protobuf field: optional string configuration_error = 4;
     */
    configurationError?: string;
    /**
     * @generated from protobuf field: optional bool checkpath_valid = 5;
     */
    checkpathValid?: boolean;
    /**
     * @generated from protobuf field: optional string first_error = 6;
     */
    firstError?: string;
    /**
     * @generated from protobuf field: map<string, motionplan.v1.JointPositions> last_good_inputs = 7;
     */
    lastGoodInputs: {
        [key: string]: JointPositions;
    };
    /**
     * Whether first_error was a collision (obstacle or self) rather than another
     * constraint violation. Set only alongside first_error.
     *
     * @generated from protobuf field: optional bool is_obstacle_collision = 8;
     */
    isObstacleCollision?: boolean;
}
/**
 * @generated from protobuf message motionplan.v1.JointPositions
 */
export interface JointPositions {
    /**
     * @generated from protobuf field: repeated double values = 1;
     */
    values: number[];
}
// @generated message type with reflection information, may provide speed optimized methods
class ComputePlanFramesRequest$Type extends MessageType<ComputePlanFramesRequest> {
    constructor() {
        super("motionplan.v1.ComputePlanFramesRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "plan_content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.ComputePlanFramesRequest
 */
export const ComputePlanFramesRequest = new ComputePlanFramesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputePlanFramesResponse$Type extends MessageType<ComputePlanFramesResponse> {
    constructor() {
        super("motionplan.v1.ComputePlanFramesResponse", [
            { no: 1, name: "steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlanStep }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.ComputePlanFramesResponse
 */
export const ComputePlanFramesResponse = new ComputePlanFramesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanStep$Type extends MessageType<PlanStep> {
    constructor() {
        super("motionplan.v1.PlanStep", [
            { no: 1, name: "transforms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Transform }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.PlanStep
 */
export const PlanStep = new PlanStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIKSolutionsRequest$Type extends MessageType<GetIKSolutionsRequest> {
    constructor() {
        super("motionplan.v1.GetIKSolutionsRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "plan_content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "num_solutions", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.GetIKSolutionsRequest
 */
export const GetIKSolutionsRequest = new GetIKSolutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIKSolutionsResponse$Type extends MessageType<GetIKSolutionsResponse> {
    constructor() {
        super("motionplan.v1.GetIKSolutionsResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IKSeedResult }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.GetIKSolutionsResponse
 */
export const GetIKSolutionsResponse = new GetIKSolutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IKSeedResult$Type extends MessageType<IKSeedResult> {
    constructor() {
        super("motionplan.v1.IKSeedResult", [
            { no: 1, name: "seed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "solutions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IKSolution }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.IKSeedResult
 */
export const IKSeedResult = new IKSeedResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IKSolution$Type extends MessageType<IKSolution> {
    constructor() {
        super("motionplan.v1.IKSolution", [
            { no: 1, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "configuration", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => JointPositions } },
            { no: 3, name: "configuration_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "configuration_error", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "checkpath_valid", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "first_error", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "last_good_inputs", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => JointPositions } },
            { no: 8, name: "is_obstacle_collision", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.IKSolution
 */
export const IKSolution = new IKSolution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JointPositions$Type extends MessageType<JointPositions> {
    constructor() {
        super("motionplan.v1.JointPositions", [
            { no: 1, name: "values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message motionplan.v1.JointPositions
 */
export const JointPositions = new JointPositions$Type();
/**
 * @generated ServiceType for protobuf service motionplan.v1.MotionPlanService
 */
export const MotionPlanService = new ServiceType("motionplan.v1.MotionPlanService", [
    { name: "ComputePlanFrames", options: {}, I: ComputePlanFramesRequest, O: ComputePlanFramesResponse },
    { name: "GetIKSolutions", options: {}, I: GetIKSolutionsRequest, O: GetIKSolutionsResponse }
]);
